export const VENDOR_STATUSES = ["active", "inactive", "temporarily_closed"];

export const VENDOR_CATEGORIES = [
  "restaurant/eatery",
  "grocery",
  "hardware",
  "pharmacy",
  "services",
  "other",
];

export const LISTING_TYPES = ["item", "package"];

export const ITEM_TYPES = ["food_item", "dry_goods"];

export const LISTING_STATUSES = [
  "active",
  "hidden",
  "out_of_stock",
  "unavailable",
];

export const VENDOR_LISTING_STATUSES = ["active", "inactive"];

export const FOOD_LISTING_SUBCATEGORIES = [
  "Rice Meals",
  "Noodles & Pasta",
  "Burgers & Sandwiches",
  "Pizza",
  "Fried Chicken & Wings",
  "Fried, Grilled & BBQ",
  "Seafood",
  "Vegetarian / Vegan",
  "Soups",
  "Salads",
  "Sides & Snacks",
  "Breakfast Meals",
  "Desserts",
  "Cakes & Bakery",
  "Milk Tea & Specialty Drinks",
  "Coffee & Hot Drinks",
  "Fresh Juices & Shakes",
  "Soft Drinks & Bottled Drinks",
  "Combo Meals / Bundles",
  "Party Trays / Platters",
];

export const NONFOOD_LISTING_SUBCATEGORIES = [
  "Fresh Fruits & Vegetables",
  "Meat & Poultry",
  "Seafood",
  "Rice, Grains & Pasta",
  "Bread & Bakery",
  "Dairy & Eggs",
  "Frozen Foods",
  "Canned & Packaged Foods",
  "Snacks & Sweets",
  "Beverages",
  "Cooking Oil, Spices & Condiments",
  "Instant & Ready-to-Eat",
  "Personal Care",
  "Toiletries & Hygiene",
  "Cleaning & Laundry Supplies",
  "Health, Medicine & First Aid",
  "Baby Care",
  "Pet Supplies",
  "Household & Kitchen Supplies",
  "Electronics & Misc Essentials",
];
